import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUndo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15.0869 2.18116C13.2851 1.18761 11.2092 0.806583 9.17196 1.09549C7.13476 1.3844 5.24664 2.32758 3.79212 3.78293L3.77677 3.79828L2 5.7375V2.99998H0V6.99998C0 7.53042 0.210714 8.0391 0.585788 8.41418C0.897393 8.72579 1.30123 8.92396 1.73314 8.98211L1.73674 8.9854L1.73904 8.98289C1.8251 8.99422 1.91225 8.99998 2 8.99998H6V6.99998H3.55582L5.2216 5.18188C6.36756 4.04168 7.85184 3.30271 9.4528 3.07568C11.0606 2.84766 12.6991 3.14839 14.1212 3.93254C15.5432 4.71668 16.6719 5.9418 17.3372 7.42324C18.0024 8.90468 18.1682 10.5622 17.8094 12.146C17.4507 13.7299 16.5869 15.1542 15.3482 16.2044C14.1096 17.2546 12.5631 17.8738 10.942 17.9687C9.32076 18.0636 7.71268 17.6289 6.36 16.7304C5.00732 15.8318 3.9833 14.5179 3.4423 12.9867L1.55655 13.653C2.24201 15.593 3.53944 17.2577 5.25332 18.3963C6.9672 19.5348 9.00472 20.0854 11.0588 19.9653C13.1128 19.8451 15.0722 19.0606 16.6416 17.7299C18.211 16.3993 19.3055 14.5946 19.76 12.5879C20.2145 10.5811 20.0046 8.481 19.1617 6.60396C18.3188 4.72692 16.8887 3.17471 15.0869 2.18116Z"
	})]
});
const ForwardRef = forwardRef(SvgUndo);
export default ForwardRef;
